export function roundToHundredths(value: number) {
  return Math.round(value * 100 + Number.EPSILON) / 100;
}

export function roundUpToTenths(value: number) {
  return Math.round(value * 10 + Number.EPSILON) / 10;
}

export function calculateCurrentPreviousDifference(current, previous) {
  const difference = (previous === current) ? 0 :
    (
      (previous > 0) ?
        Math.round(100 * (current - previous) / previous) : (current - previous)
    );
  const absDifference = (previous === current) ? 0 :
    (
      (previous > 0) ?
        Math.abs(Math.round(100 * (current - previous) / previous)) : '∞ '
    );
  return {
    current: roundToHundredths(current),
    difference: difference,
    absDifference: absDifference
  };
}

export function chartBarPercentDifference(arr, newArr) {
  const maxPercent = Math.max.apply(null, arr.map(item => item.mainPercent));
  const difference = 100 - maxPercent;
  arr.forEach(item => {
    const dividingRemainder = ((item.mainPercent / maxPercent) * 100);
    if (difference < 100) {
      if (item.mainPercent !== 0 && item !== maxPercent) {
        item.percentForChart = dividingRemainder;
      }
      if (item.mainPercent === 0) {
        item.percentForChart = 0.1;
      }
      if (item.mainPercent === maxPercent) {
        item.percentForChart = item.mainPercent + difference;
      }
      item.percentForFirstChart = ((item.percentForFirstChart / item.mainPercent) * 100);
      item.percentForSecondChart = ((item.percentForSecondChart / item.mainPercent) * 100);
    }
    newArr.push(item);
  });
  return newArr;
}
